export default {
	install(Vue, options) {
		Vue.prototype.$log = {
			log: function() {
				// console.log('args', arguments);
				this.showMessage('log', arguments);
			}
			,info: function() {
				// console.log('args', arguments);
				this.showMessage('info', arguments);
			}
			,error: function() {
				// console.log('args', arguments);
				this.showMessage('error', arguments);
			}
			,showMessage: function(type, params) {
				if (process.env.VUE_APP_SHOW_LOGS)
					switch(type) {
						case 'log':
							console.log.apply(null, params);
							break;
						case 'info':
							console.info.apply(null, params);
							break;
						case 'error':
							console.error.apply(null, params);
							break;
					}
			}
		}
	}
}